<h1 mat-dialog-title class="p-2 text-center">Ajout d'un appareil</h1>
<div mat-dialog-content class="p-3">

    <div class="row rounded-1 background-light mb-3 py-3">

        <mat-form-field class="col-12">
            <mat-label>Type d'appareil</mat-label>
            <mat-select placeholder="Type d'appareil" [(ngModel)]="Model.Type" (selectionChange)="getAvailableBrandAndModel()" required>
                @for (o of TypeAppareilList; track o; let i = $index) {
                <mat-option [value]="o.idx">
                    <span>{{o.s}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Marque</mat-label>
            <mat-select placeholder="Marque" [(ngModel)]="Model.Marque" required>
                @for (o of MarqueAppareilList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Modèle</mat-label>
            <mat-select placeholder="Modèle" [(ngModel)]="Model.Modele" required>
                @for (o of ModeleAppareilList; track o; let i = $index) {
                <mat-option [value]="i + 1">
                    <span>{{o}}</span>
                </mat-option>
                }
            </mat-select>
        </mat-form-field>

        <mat-form-field class="col-12">
            <mat-label>Numéro Interne</mat-label>
            <input matInput [(ngModel)]="Model.NumeroInterne" placeholder="Numéro Interne">
        </mat-form-field>
    </div>

    <div class="row mt-3 g-0">
        <button appPreventDoubleClick class="col me-1" color="basic" mat-stroked-button (throttledClick)="onCancel()">
            Annuler
        </button>
        <button appPreventDoubleClick class="col ms-1" color="accent" mat-raised-button (throttledClick)="onConfirm()" [disabled]="!canSave()">
            Valider
        </button>
    </div>
</div>